export default __webpack_public_path__ + "static/media/logowhite.5e0da16c.svg";